import React from 'react'
import Section from './Section'
import Section1 from './Section1'
import Navbar1 from '../../layout/Navbar1'

const Index7 = () => {
  return (
    <React.Fragment>
        <Navbar1 />
        <Section />
        <Section1 />
    </React.Fragment>
  )
}

export default Index7